/* unplugin-vue-components disabled */import { render, staticRenderFns } from "./GradeTable.vue?vue&type=template&id=52c41733&"
import script from "./GradeTable.vue?vue&type=script&lang=js&"
export * from "./GradeTable.vue?vue&type=script&lang=js&"
import style0 from "./GradeTable.vue?vue&type=style&index=0&id=52c41733&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports